import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-circle-icon",
  "use": "icon-circle-icon-usage",
  "viewBox": "0 0 19.75 19.75",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 19.75 19.75\" id=\"icon-circle-icon\">\n<path fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-width=\"2.5px\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\" fill=\"none\" d=\"M9.250,1.250 C13.668,1.250 17.250,4.832 17.250,9.250 C17.250,13.668 13.668,17.250 9.250,17.250 C4.832,17.250 1.250,13.668 1.250,9.250 C1.250,4.832 4.832,1.250 9.250,1.250 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol